"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = require("./common");

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuelidate/lib/validators/numeric.js
// module id = 771
// module chunks = 0 2 3 4 5 6 7 8 9 10 11 12 17 18 19 20 22 23 24 26 28 29 30 32 33 34